import { getPedidosDaCarga, getProdutosDaCarga, getAllData, locationDev } from "./Servicos";
import { pdf } from "@react-pdf/renderer";
import PDFRelatorioFinalCarga from "../components/pdf/PDFRelatorioFinalCarga";
import PDFFolhaRostoCTE from "../components/pdf/PDFFolhaRostoCTE";
import { PDFDocument } from "pdf-lib";
import axios from "axios";

/**
 * Baixa um PDF de uma URL
 * @param {string} route - Rota relativa do arquivo (ex: 'gerenciamento-ctes/123/download')
 * @returns {Promise<ArrayBuffer>}
 */
const baixarPDF = async (route) => {
  return await axios({
    method: "get",
    url: `${locationDev}${route}`,
    responseType: "arraybuffer",
    headers: {
      Authorization: `JWT ${localStorage.getItem("token")}`,
      "Content-Type":"application/pdf"
    },
  })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      throw error;
    });
};

/**
 * Gera relatório final da carga em formato PDF e faz download
 * @param {Object} carga - Dados da carga
 * @returns {Promise<void>}
 */
export const gerarRelatorioFinalCarga = async (carga) => {
  try {
    // Buscar pedidos e produtos da carga
    const pedidosResponse = await getPedidosDaCarga(carga.id);
    const pedidos = pedidosResponse.data;

    const produtosResponse = await getProdutosDaCarga(carga.id);
    const produtos = produtosResponse.data;

    // Buscar CTEs da carga, se foram passados
    let ctesComDados = [];
    if (carga.ctes && carga.ctes.length > 0) {
      try {
        const { data } = await getAllData(`gerenciamento-ctes/cargas/${carga.id}`);
        ctesComDados = data || [];
      } catch (error) {
        console.warn("Erro ao buscar CTEs:", error);
        // Continua mesmo se não conseguir buscar os CTEs
      }
    }

    // Criar o documento PDF principal usando o componente (sem CTEs internos)
    const cargaSemCTEsInternos = {
      ...carga,
      ctes: [] // Remover CTEs para não criar as folhas de rosto
    };
    
    const doc = <PDFRelatorioFinalCarga carga={cargaSemCTEsInternos} pedidos={pedidos} produtos={produtos} />;
    
    // Gerar o blob do PDF principal
    const asPdf = pdf(doc);
    const pdfBlob = await asPdf.toBlob();
    
    // Se não há CTEs, fazer download direto
    if (!ctesComDados || ctesComDados.length === 0) {
      const url = window.URL.createObjectURL(pdfBlob);
      const link = document.createElement("a");
      link.href = url;
      const nomeArquivo = `Relatorio_Final_Carga_${carga.id}_${carga.nome.replace(
        /[^a-zA-Z0-9]/g,
        "_"
      )}.pdf`;
      link.download = nomeArquivo;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      return;
    }

    // Carregar o PDF principal com pdf-lib
    const pdfPrincipalBytes = await pdfBlob.arrayBuffer();
    const pdfFinal = await PDFDocument.load(pdfPrincipalBytes);

    // Baixar e mesclar cada CTE
    for (let i = 0; i < ctesComDados.length; i++) {
      const cte = ctesComDados[i];
      try {
        // 1. Gerar folha de rosto para este CTE
        const folhaRostoDoc = <PDFFolhaRostoCTE 
          cte={cte} 
          carga={carga} 
          index={i} 
          totalCTEs={ctesComDados.length} 
        />;
        const folhaRostoPdf = pdf(folhaRostoDoc);
        const folhaRostoBlob = await folhaRostoPdf.toBlob();
        const folhaRostoBytes = await folhaRostoBlob.arrayBuffer();
        const folhaRostoPdfDoc = await PDFDocument.load(folhaRostoBytes);
        
        // Copiar a folha de rosto para o PDF final
        const folhaRostoPaginas = await pdfFinal.copyPages(folhaRostoPdfDoc, folhaRostoPdfDoc.getPageIndices());
        folhaRostoPaginas.forEach((pagina) => {
          pdfFinal.addPage(pagina);
        });
        
        // 2. Baixar e adicionar o PDF do CTE
        const routeCTE = `/gerenciamento-ctes/${cte.id}/download`;
        
        // Baixar o PDF do CTE
        const ctePdfBytes = await baixarPDF(routeCTE);
        
        // Carregar o PDF do CTE
        const ctePdf = await PDFDocument.load(ctePdfBytes);
        
        // Copiar todas as páginas do CTE para o PDF final
        const paginasCopiadas = await pdfFinal.copyPages(ctePdf, ctePdf.getPageIndices());
        
        // Adicionar as páginas copiadas ao PDF final
        paginasCopiadas.forEach((pagina) => {
          pdfFinal.addPage(pagina);
        });
        
        console.log(`CTE ${i + 1}/${ctesComDados.length} adicionado: ${cte.descricao}`);
      } catch (error) {
        console.error(`Erro ao adicionar CTE ${cte.descricao}:`, error);
        // Continua com os próximos CTEs mesmo se houver erro
      }
    }

    // Salvar o PDF final mesclado
    const pdfFinalBytes = await pdfFinal.save();
    const pdfFinalBlob = new Blob([pdfFinalBytes], { type: "application/pdf" });
    
    // Fazer download do PDF final
    const url = window.URL.createObjectURL(pdfFinalBlob);
    const link = document.createElement("a");
    link.href = url;
    const nomeArquivo = `Relatorio_Final_Carga_${carga.id}_${carga.nome.replace(
      /[^a-zA-Z0-9]/g,
      "_"
    )}.pdf`;
    link.download = nomeArquivo;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
    
  } catch (error) {
    console.error("Erro ao gerar relatório:", error);
    throw new Error("Erro ao gerar relatório final da carga");
  }
};
